import { createI18n } from 'vue-i18n'

import { messages } from "./locale/index.js";

export default createI18n({
  locale: window.Laravel.locale, // set locale
  fallbackLocale: "en", // set fallback locale
  messages: messages, // set locale messages
})